import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Navbar = () => {
  return (
    <>
      <nav className="navbar">
        <Link to="/privacy-policy" className="navbar-brand">
          Memory Match
        </Link>
        <div className="navbar-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
